import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
const TARGET_RAW_FLOW = {
    id: 'target_material_raw_flow',
    type: 'target',
    name: 'Сырьё',
    position: Position.Left,
    style: { top: 72, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_HYDROGEN_FLOW = {
    id: 'target_material_hydrogen_flow',
    type: 'target',
    name: 'Циркулирующий ВСГ',
    position: Position.Left,
    style: { top: 52, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_GAS_WITH_WATER_FLOW = {
    id: 'source_material_flow_gas_with_water',
    type: 'source',
    name: 'Газы+$H_2O$',
    position: Position.Right,
    style: { top: 23, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_GAS_FLOW = {
    id: 'source_material_gas_flow',
    type: 'source',
    name: 'ВСГ',
    position: Position.Right,
    style: { top: 43, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_HYDROGEN_FLOW = {
    id: 'source_material_hydrogen_flow',
    type: 'source',
    name: 'Водород',
    position: Position.Right,
    style: { top: 43, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_TOP_FLOW = {
    id: 'source_material_top_product',
    type: 'source',
    name: 'Углеводородные газы',
    position: Position.Right,
    style: { top: 63, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_WATER_FLOW = {
    id: 'source_material_water',
    type: 'source',
    name: 'Вода',
    position: Position.Right,
    style: { top: 83, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_1_FLOW = {
    id: 'source_material_frac_1',
    type: 'source',
    name: 'Сжиженные газы',
    position: Position.Right,
    style: { top: 103, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_BOTTOM_FLOW = {
    id: 'source_material_bottom_product',
    type: 'source',
    name: 'Стабильный риформат',
    position: Position.Right,
    style: { top: 122, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_LIQUID_FLOW = {
    id: 'source_material_liquid_flow',
    type: 'source',
    name: 'Углеводороды',
    position: Position.Right,
    style: { top: 142, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_LOGICAL = {
    id: 'target_logical_flow',
    type: 'target',
    name: 'Входные параметры',
    position: Position.Left,
    style: { top: 178, left: 9, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_LOGICAL = {
    id: 'source_logical_flow',
    type: 'source',
    name: 'Выходные параметры',
    position: Position.Right,
    style: { top: 178, right: 8, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
export const CAT_REFORMING_CONFIG = {
    type: ERFElement.CatReforming,
    icon: 'CatReforming_2d',
    templates: [
        {
            code: 'fixedbed-template_mixer_reactorblock_separator',
            ports: [
                TARGET_RAW_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'fixedbed-template_mixer_reactorblock_separator_fractionator',
            ports: [
                TARGET_RAW_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_FLOW,
                SOURCE_WATER_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_BOTTOM_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'fixedbed-template_mixer_reactorblock_separator_componentsplitter_compressor',
            ports: [
                TARGET_RAW_FLOW,
                SOURCE_GAS_WITH_WATER_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'fixedbed-template_mixer_reactorblock_separator_componentsplitter_compressor_fractionator',
            ports: [
                TARGET_RAW_FLOW,
                SOURCE_GAS_WITH_WATER_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_TOP_FLOW,
                SOURCE_WATER_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_BOTTOM_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'fixedbed-template_mixer_reactorblock_separator_compressor',
            ports: [
                TARGET_RAW_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'fixedbed-template_mixer_reactorblock_separator_compressor_fractionator',
            ports: [
                TARGET_RAW_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_TOP_FLOW,
                SOURCE_WATER_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_BOTTOM_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        }
    ]
};
//# sourceMappingURL=RFCatReformingNode.config.js.map